<script>
import {mapMutations, mapGetters} from 'vuex'
import $ from 'jquery'
export default {
  props: ['merchantNo', 'messages'],
  data () {
    return {
      content: ''
    }
  },
  computed: {
    ...mapGetters([
      'curMessageSession'
    ])
  },
  methods: {
    ...mapMutations([
      'SEND_MESSAGE', 'INIT_MESSAGE'
    ]),
    onKeyup (e) {
      if (e.keyCode === 13 && this.content.length > 1 && this.content.trim() !== '') {
        let data = {}
        data.message = this.content
        data.merchandise = this.$route.params.merchandises
        data.merchantNo = this.merchantNo
        this.SEND_MESSAGE(data)
        this.INIT_MESSAGE('INIT_MESSAGE')
        var newdata = {}
        newdata.message = this.content
        newdata.messageType = 1
        this.messages.push(newdata)

//        this.messageSessions[0].messages.push({
//          message: this.content,
//          createDT: new Date(),
//          messageType: 1
//        })
        $('#prompt').css('display', 'block')
        $('#prompt').fadeIn('fast', function () {
          window.setTimeout(function () {
            $('#prompt').fadeOut('fast', function () {
              $('#prompt').css('display', 'none')
            })
          }, 3000)
        })
        this.content = ''
      }
    }
  }
}
</script>

<template>
<div class="text">
  <div  id="prompt" style="font-size: 0.6rem;display: none;">您的消息已经收到啦， 客服人员会尽快回复的。</div>
    <textarea placeholder="按 回车键(换行) 发送" v-model="content" @keyup="onKeyup"></textarea>
</div>
</template>

<style lang="less" scoped>
.text {
    height: 10rem;
    border-top: solid 0.1rem #ddd;

    textarea {
        padding: 0.6rem;
        height: 100%;
        width: 100%;
        border: none;
        outline: none;
        font-family: "Micrsofot Yahei";
        resize: none;
    }
}
</style>



// WEBPACK FOOTER //
// MessageText.vue?7c30ee16